import { z } from "zod";
import type { infer as zInfer } from "zod";
import { currency } from "@/hooks/firestore/models/currency";

export const withdrawal = z.object({
  amount: z.number(),
  cancellable: z.boolean(),
  currency,
  createdAt: z.string(),
  status: z.enum(["PENDING", "FAILED"]),
});

export type Withdrawal = zInfer<typeof withdrawal>;
